/* tslint:disable */
/* eslint-disable */
/**
 * Documents API
 * CDI Documents API
 *
 * The version of the OpenAPI document: 1.33.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from '../runtime';
/**
 * Check if a given object implements the Translations interface.
 */
export function instanceOfTranslations(value) {
    let isInstance = true;
    return isInstance;
}
export function TranslationsFromJSON(json) {
    return TranslationsFromJSONTyped(json, false);
}
export function TranslationsFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        languageId: !exists(json, 'languageId') ? undefined : json['languageId'],
        locale: !exists(json, 'locale') ? undefined : json['locale'],
        languageCode: !exists(json, 'languageCode') ? undefined : json['languageCode'],
        lcid: !exists(json, 'lcid') ? undefined : json['lcid'],
        title: !exists(json, 'title') ? undefined : json['title'],
        subject: !exists(json, 'subject') ? undefined : json['subject'],
        body: !exists(json, 'body') ? undefined : json['body']
    };
}
export function TranslationsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        languageId: value.languageId,
        locale: value.locale,
        languageCode: value.languageCode,
        lcid: value.lcid,
        title: value.title,
        subject: value.subject,
        body: value.body
    };
}
